import { useMemo } from 'react';

import { Permissions } from 'src/utils/constants';

import { usePermissions } from 'src/auth/context/permission-context';

export function usePermission() {
  const { hasPermission, hasSpecialPermission, moduleId, isLoading } = usePermissions();

  return useMemo(
    () => ({
      // Mevcut modül ID'si
      moduleId,

      // Loading durumu
      isLoading,

      // Temel izin kontrol fonksiyonları
      hasPermission,
      hasSpecialPermission,

      // Standart izin kontrol metodları
      canDefault: () => hasPermission(Permissions.DEFAULT),
      canView: () => hasPermission(Permissions.VIEW),
      canAdd: () => hasPermission(Permissions.ADD),
      canUpdate: () => hasPermission(Permissions.UPDATE),
      canDelete: () => hasPermission(Permissions.DELETE),
      canBulk: () => hasPermission(Permissions.BULK),
      canPrint: () => hasPermission(Permissions.PRINT),
      canHomeModuleDropdownApproval: () =>
        hasSpecialPermission(Permissions.HOMEMODULE_DROPDOWN_APPROVAL),
      canHomeModuleReportSummaryView: () =>
        hasSpecialPermission(Permissions.HOMEMODULE_REPORT_SUMMARY_VIEW),
      canHomeModuleApprovalWaitingPaymentsApprove: () =>
        hasSpecialPermission(Permissions.HOMEMODULE_APPROVAL_WAITING_PAYMENTS_APPROVE),
      canHomeModuleApprovalWaitingPaymentsView: () =>
        hasSpecialPermission(Permissions.HOMEMODULE_APPROVAL_WAITING_PAYMENTS_VIEW),
      canHomeModuleApprovalWaitingJuriesApprove: () =>
        hasSpecialPermission(Permissions.HOMEMODULE_APPROVAL_WAITING_JURIES_APPROVE),
      canHomeModuleApprovalWaitingJuriesView: () =>
        hasSpecialPermission(Permissions.HOMEMODULE_APPROVAL_WAITING_JURIES_VIEW),
      canHomeModuleRouterLinkView: () =>
        hasSpecialPermission(Permissions.HOMEMODULE_ROUTER_LINK_VIEW),
      canHomeModuleJury: () => hasSpecialPermission(Permissions.HOMEMODULE_JURY),
      canHomeModuleCreateNotification: () =>
        hasSpecialPermission(Permissions.HOMEMODULE_CREATE_NOTIFICATION),
      canProjectModuleSetAsFinalist: () =>
        hasSpecialPermission(Permissions.PROJECTMODULE_SET_AS_FINALIST),
      canProjectModuleUpdateFinalistProject: () =>
        hasSpecialPermission(Permissions.PROJECTMODULE_UPDATE_FINALIST_PROJECT),
      // Document module specific permissions
      canViewJudgeFiles: () => hasSpecialPermission(Permissions.DOCUMENTS_JUDGE_FILES),
      canViewCompetitionFiles: () => hasSpecialPermission(Permissions.DOCUMENTS_COMPETITION_FILES),
      // Payment module specific permissions
      canPaymentDefer: () => hasSpecialPermission(Permissions.PAYMENT_DEFER),
      // Judgement Evaluation module specific permissions
      canSelectJudge: () => hasSpecialPermission(Permissions.JUDGEMENT_EVALUATION_SELECT_JUDGE),
    }),
    [hasPermission, hasSpecialPermission, moduleId, isLoading]
  );
}
